export default class ProductsList {
    constructor(options) {
        const _defaults = {};
        this.defaults = Object.assign({}, _defaults, options);
    }

    init() {
        this.viewToggle();
        this.getCookieView();
        this.mobileFiltersTrigger();
        this.productsLoader();
    }

    viewToggle() {
        $('.berocket_lgv_button_list').on('click', function () {
            $('body').addClass('list-view');
            for (let el of document.querySelectorAll('.publisher_value_class')) el.style.display = 'none';
            for (let el of document.querySelectorAll('.woocommerce-loop-product__title')) el.style.display = 'none';
        })
        $('.berocket_lgv_button_grid').on('click', function () {
            $('body').removeClass('list-view');
            for (let el of document.querySelectorAll('.publisher_value_class')) el.style.display = 'block';
            for (let el of document.querySelectorAll('.woocommerce-loop-product__title')) el.style.display = 'block';
        })
    }

    getCookieView() {

        let productViewType = document.cookie.replace(/(?:(?:^|.*;\s*)br_lgv_stat\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if(productViewType == ""){
            $('body').addClass('list-view');
        }

        if (productViewType == "list%7Cdefault"){
            for (let el of document.querySelectorAll('.publisher_value_class')) el.style.display = 'none';
            for (let el of document.querySelectorAll('.woocommerce-loop-product__title')) el.style.display = 'none';
            $('body').addClass('list-view')
        }else{
            $('body').removeClass('list-view');
        }

        if ($('.related_products_for_grid_view').length > 0) {
            $('body').removeClass('list-view');
        }

    }

    mobileFiltersTrigger() {
        $('.js-products-fiters-trigger').on('click', function () {
            let productsListWrapper = $('.js-products-filters-results');
            let productsListWidth = productsListWrapper.width();
            $('.js-products-filters').toggleClass('is-active');


            if ($('.js-products-filters').hasClass('is-active')) {
                productsListWrapper.css({
                    "min-width": productsListWidth
                });
            } else {
                productsListWrapper.css({
                    "min-width": '100%'
                });
            }

        })
    }

    productsLoader() {
        setTimeout(function () {
            $('.js-products-filters-results-loader').addClass('hide');
        }, 100)
    }

}


// WEBPACK FOOTER //
// ./static/js/components/ProductsList.js